@if (lineSize === 0) {
  <div class="checkbox-group" [ngClass]="orientation" [attr.disabled]="notEnabled?'':null">
    @for (so of options; track so) {
      <div class="checkbox">
        <aa-checkbox [toTranslate]="toTranslate" [option]="so"> </aa-checkbox>
      </div>
    }
  </div>
}
@if (lineSize !== 0) {
  <div class="checkbox-group" [attr.disabled]="notEnabled?'':null">
    <table>
      @for (line of lines; track line; let i = $index) {
        <tr>
          @for (so of options.slice(i * lineSize, (i + 1) * lineSize); track so) {
            <td>
              <aa-checkbox [toTranslate]="toTranslate" [option]="so"> </aa-checkbox>
            </td>
          }
        </tr>
      }
    </table>
  </div>
}
